<template lang="html">
  <el-form ref="form" v-form :model="form" addAction="lcwpbusiness/insertBusiness.action" editAction="lcwpbusiness/updateBusiness.action" selectAction="lcwpbusiness/selectBusinessInfo.action" :rules="rules" label-width="150px">
      <el-col :span="12">

          <el-form-item label="商家名称" prop="businessName">
              <el-input type="text" v-model="form.businessName" placeholder="比如，宝渝宝马4S店（巴南店）"></el-input>
          </el-form-item>

          <el-form-item label="商家类型" prop="type">
              <el-select  v-model="form.type" placeholder="请选择商家类型">
                  <el-option label="4S店" value="4S店"></el-option>
                  <el-option label="综合汽贸" value="综合汽贸"></el-option>
                 <el-option label="二手车" value="二手车">二手车</el-option>
                 <el-option label="机油保养" value="机油保养">机油保养</el-option>
                  <el-option label="洗车打蜡" value="洗车打蜡">洗车打蜡</el-option>
                  <el-option label="汽车用品" value="汽车用品">汽车用品</el-option>
                  <el-option label="改装装潢" value="改装装潢">改装装潢</el-option>
                  <el-option label="汽车维修" value="汽车维修">汽车维修</el-option>
                  <el-option label="车驾管服务" value="车驾管服务">车驾管服务</el-option>
                  <el-option label="保险服务" value="保险服务">保险服务</el-option>
                  <el-option label="驾培服务" value="驾培服务">驾培服务</el-option>
                  <el-option label="其他商户" value="其他商户">其他商户</el-option>
              </el-select>
          </el-form-item>

          <el-form-item v-if="form.type=='4S店'||form.type=='综合汽贸'" label="入驻品牌" prop="assignedToTheBrand">
            <brand-and-factory-select ref="brand-and-factory-select"  @onChanged="onChanged"></brand-and-factory-select>
          </el-form-item>

          <el-form-item v-if="isAdmin" label="展示渠道" prop="channelId">
            <channel-select ref="channelSelect" placeholder="请输入关键字搜索"  @change="channelIdsChange"></channel-select>
          </el-form-item>

          <el-form-item label="服务类型" prop="serviceType">
            <el-select multiple v-model="form.serviceType" placeholder="请选择服务类型">

                <el-option label="新车" value="新车"></el-option>
              <el-option label="二手车" value="二手车"></el-option>
              <el-option label="机油保养" value="机油保养"></el-option>
                <el-option label="洗车打蜡" value="洗车打蜡"></el-option>
                <el-option label="汽车用品" value="汽车用品"></el-option>
                <el-option label="改装装潢" value="改装装潢"></el-option>
                <el-option label="汽车维修" value="汽车维修"></el-option>
                <el-option label="车驾管服务" value="车驾管服务">车驾管服务</el-option>
                <el-option label="保险服务" value="保险服务">保险服务</el-option>
                <el-option label="驾培服务" value="驾培服务">驾培服务</el-option>
                <el-option label="其他服务" value="其他服务"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商家地址" prop="address">
                  <search-address-input ref="business-address" v-model="form.address" placeholder="请选择（支持搜索联想输入）" :defaultValue="form.address" @onChenged="onChange"></search-address-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="门店负责人" prop="contacts">
              <el-input type="text" v-model="form.contacts" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="联系手机" prop="phone">
              <el-input type="text" :disabled="form.id!=null" v-model="form.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="营业执照编号" prop="licenseNo">
              <el-input type="text" v-model="form.licenseNo" placeholder="请输入营业执照编号"></el-input>
          </el-form-item>
          <el-form-item label="上传门店营业执照：" prop="licensePhoto">

              <draggable v-model="form.licensePhoto" tag="ul" class="img-temp-list" draggable=".img-temp-item">
                  <li class="img-temp-item" v-for="(item, i) in form.licensePhoto" :key="i">
                      <img :src="item.url" />
                      <div class="img-action">
                          <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                          <i class="el-icon-delete" @click="removeFile(form.licensePhoto,i)"></i>
                      </div>
                  </li>
                  <el-upload
                          :before-upload="(file) => beforeAvatarUpload(file, form.licensePhoto,1)"
                          :show-file-list="false"
                          :data="{floder:'bussinessProduct'}"
                          :file-list="form.licensePhoto"
                          :http-request="onHttpRequest"
                          :limit="9"
                          accept="image/*"
                          action="upload/uploadPic"
                          list-type="picture-card"
                          multiple
                          ref="licensePhoto"
                          v-model="form.licensePhoto">

                      <i class="el-icon-plus"></i>

                  </el-upload>
                  <div slot="tip" class="el-upload__tip">   <p style="color:#666;padding-left: 10px;">建议尺寸：750*460px<span style="color:red;"> 最多1张</span></p></div>
              </draggable>

          </el-form-item>
          <el-form-item label="上传门店封面图：" prop="headImg">

              <draggable v-model="form.headImg" tag="ul" class="img-temp-list" draggable=".img-temp-item">
                  <li class="img-temp-item" v-for="(item, i) in form.headImg" :key="i">
                      <img :src="item.url" />
                      <div class="img-action">
                          <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                          <i class="el-icon-delete" @click="removeFile(form.headImg,i)"></i>
                      </div>
                  </li>
                  <el-upload
                          :before-upload="(file) => beforeAvatarUpload(file, form.headImg,1)"
                          :show-file-list="false"
                          :data="{floder:'bussinessProduct'}"
                          :file-list="form.headImg"
                          :http-request="onHttpRequest"
                          :limit="9"
                          accept="image/*"
                          action="upload/uploadPic"
                          list-type="picture-card"
                          multiple
                          ref="licensePhoto"
                          v-model="form.headImg">

                      <i class="el-icon-plus"></i>

                  </el-upload>
                  <div slot="tip" class="el-upload__tip">   <p style="color:#666;padding-left: 10px;">建议尺寸：750*460px<span style="color:red;"> 最多1张</span></p></div>
              </draggable>

          </el-form-item>

          <el-form-item label="上传门店实拍图：" prop="img">

              <draggable v-model="form.img" tag="ul" class="img-temp-list" draggable=".img-temp-item">
                  <li class="img-temp-item" v-for="(item, i) in form.img" :key="i">
                      <img :src="item.url" />
                      <div class="img-action">
                          <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                          <i class="el-icon-delete" @click="removeFile(form.img,i)"></i>
                      </div>
                  </li>
                  <el-upload
                          :before-upload="(file) => beforeAvatarUpload(file, form.img,9)"
                          :show-file-list="false"
                          :data="{floder:'bussinessProduct'}"
                          :file-list="form.img"
                          :http-request="onHttpRequest"
                          :limit="9"
                          accept="image/*"
                          action="upload/uploadPic"
                          list-type="picture-card"
                          multiple
                          ref="licensePhoto"
                          v-model="form.img">

                      <i class="el-icon-plus"></i>

                  </el-upload>
                  <div slot="tip" class="el-upload__tip">   <p style="color:#666;padding-left: 10px;">建议尺寸：750*460px<span style="color:red;"> 最多9张</span></p></div>
              </draggable>

          </el-form-item>

      </el-col>

      <el-col>
          <el-form-item>
              <el-button type="primary">保存</el-button>

          </el-form-item>

      </el-col>

  </el-form>
</template>

<script>
import SearchAddressInput from '@/components/SearchAddressInput'
import BrandAndFactorySelect from '@/components/BrandAndFactorySelect'
import Config from '@/framework/configs/Config'
import channelSelect from '@/components/channelSelect'

import BasicPager from '@/mixins/BasicPager'
export default {
  extends: BasicPager,
  components: {
    SearchAddressInput,
    BrandAndFactorySelect,
    channelSelect
  },
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      baseSmalIcon: 'ClueDistribution/fdjxtb.png',
      isAdmin: null,
      form: {
        img: [],
        licenseNo: null,
        imgShowList: [],
        address: null,
        location: [106.566129, 29.645191],
        assignedToTheBrand: [],
        channelId: null,
        licensePhoto: [],
        headImg: []
      },
      rules: {
        type: [{
          required: true,
          trigger: 'change',
          message: '商家类型不能为空！'
        }],
        serviceType: [{
          required: true,
          trigger: 'change',
          message: '服务类型不能为空！'
        }],
        address: [{
          required: true,
          message: '地理位置不能为空！'
        }],
        contacts: [{
          required: true,
          message: '门店负责人不能为空！'
        }],
        phone: [{
          required: true,
          message: '门店电话不能为空！'
        }]
      }
    }
  },
  created: function () {
    this.form.id = this.$route.params.id

    if (this.$route.params.carShowId) {
      this.form.carShowId = this.$route.params.carShowId
    }

    if (this.loginInfo.loginPath == 'channel') {
      this.form.channelId = this.loginInfo.id
    }

    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
  },
  methods: {
    beforeAvatarUpload (file, datas, limitSize) {
      debugger
      let _this = this
      let promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 15MB!')
          reject(new Error('上传头像图片大小不能超过 15MB!'))
          return
        }

        if (datas.length >= limitSize) {
          _this.$message.error('最多只能上传' + limitSize + '张!')
          reject(new Error('最多只能上传' + limitSize + '张'))
          return
        }
        resolve()
      })
      return promise
    },
    removeFile (list, index) {
      list.splice(index, 1)
    },
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.form.channelId = channelId
      } else {
        this.form.channelId = null
      }
    },
    onChanged: function (brands) {
      this.form.assignedToTheBrand = JSON.stringify(brands)
    },
    onChange: function (addressInfo) {
      // 查询省市区areaCode
      // this.form.address = addressInfo.value

      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county

      this.form.city = city
      this.center = addressInfo.location.split(',')
      this.form.location = addressInfo.location.split(',')

      this.form.detailAddress = addressInfo.value.replace(city + ' ', '')
      this.form.longitude = this.form.location[0]
      this.form.latitude = this.form.location[1]
    },
    onFilterParams: function (params) {
      if (!['4S店', '综合汽贸'].includes(params.type)) {
        params.assignedToTheBrand = '[]'
      }
    },

    onSelectInfo: function (dataInfo) {
      this.form.address = dataInfo.datas.detailAddress

      this.$nextTick(function () {
        this.form.location = [dataInfo.datas.longitude, dataInfo.datas.latitude]
      })

      this.form.assignedToTheBrand = dataInfo.datas.assignedToTheBrand

      this.$nextTick(function () {
        let brandAndFactorySelect = this.$refs['brand-and-factory-select']

        if (brandAndFactorySelect) {
          brandAndFactorySelect.setValue(dataInfo.datas.assignedToTheBrand)
        }

        this.$refs['channelSelect'].setChannelIds(dataInfo.datas.channelId)

        this.$refs['channelSelect'].settingDefaultChannelInfo({ id: dataInfo.datas.channelId, channelName: dataInfo.datas.channelName })
      })
    }
  }
}
</script>

<style scoped>

    .img-temp-list {
        padding-left: 0;
        display: flex;
        align-items: center;
        flex-warp: warp;
    }

    .img-temp-item {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;
    }

    .img-temp-item img {
        width: 100%;
        height: 100%;
    }
    .img-temp-item:hover .img-action {
        opacity: 1;
    }

    .img-temp-item .img-action {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        opacity: 0;
    }
    .img-action i {
        font-size: 20px;
        color: #fff;
        margin-left: 15px;
        cursor: pointer;
    }
    .img-action i:first-child {
        margin-left: 0;
    }
</style>
